import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { screenHostLogin } from '../../../services/screenHostLogin';
import { persistUserSession } from '../../../services/userSession';
import { persistRoleSession } from '../../../services/authSession';
import { prepareLoginPage } from '../../../services/prepareLoginPage';
import './ScreenHostLogin.css';

export default function ScreenHostLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        prepareLoginPage();
    }, []);

    function onSubmit(event) {
        event.preventDefault();
        setError('');
        setLoading(true);

        screenHostLogin(email.trim(), password)
            .then((response) => {
                const data = response.data;
                persistUserSession({
                    token: data.token,
                    refreshToken: data.refreshToken,
                    userId: data.userId,
                    phoneNumber: data.phoneNumber,
                    email: email.trim()
                });
                persistRoleSession({
                    role: 'user',
                    token: data.token,
                    refreshToken: data.refreshToken,
                    name: data.fname ? `${data.fname} ${data.lname || ''}`.trim() : undefined
                });
                if (data.userId) {
                    localStorage.setItem('userId', String(data.userId));
                }
                if (data.fname) {
                    localStorage.setItem('name', `${data.fname} ${data.lname || ''}`.trim());
                }
                if (data.requiresAgreement) {
                    navigate('/screen-host/accept', {
                        replace: true,
                        state: {
                            token: data.token,
                            refreshToken: data.refreshToken,
                            userId: data.userId,
                            phoneNumber: data.phoneNumber
                        }
                    });
                } else {
                    navigate('/user/compose', {
                        replace: true,
                        state: {
                            userId: data.userId,
                            phoneNumber: data.phoneNumber,
                            token: data.token
                        }
                    });
                }
            })
            .catch((err) => {
                const msg =
                    err.response?.data?.message ||
                    err.response?.data?.error ||
                    'Login failed. Please check your email and password.';
                setError(typeof msg === 'string' ? msg : 'Login failed.');
            })
            .finally(() => setLoading(false));
    }

    return (
        <div className="screen-host-login-page">
            <nav className="screen-host-login-nav">
                <button type="button" className="screen-host-login-brand" onClick={() => navigate('/')}>
                    INVERT
                </button>
            </nav>
            <main className="screen-host-login-main">
                <form className="screen-host-login-card" onSubmit={onSubmit}>
                    <h1>Screen host sign in</h1>
                    <p className="screen-host-login-subtitle">
                        Sign in with the email and password you used when creating your account.
                    </p>
                    <label htmlFor="screen-host-email">Email</label>
                    <input
                        id="screen-host-email"
                        type="email"
                        required
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <label htmlFor="screen-host-password">Password</label>
                    <input
                        id="screen-host-password"
                        type="password"
                        required
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    {error && <p className="screen-host-login-error">{error}</p>}
                    <button type="submit" className="screen-host-login-submit" disabled={loading}>
                        {loading ? 'Signing in…' : 'Sign in'}
                    </button>
                    <p className="screen-host-login-footer">
                        <Link to="/screenHostSignup">Create account</Link>
                        {' · '}
                        <Link to="/screen-host-agreement">View host agreement</Link>
                        {' · '}
                        <Link to="/userLogin/">Phone login</Link>
                    </p>
                </form>
            </main>
        </div>
    );
}
